import { isPlatformBrowser } from "@angular/common";
import { inject, Injectable, PLATFORM_ID } from "@angular/core";

@Injectable({ providedIn: 'root' })

export class ContextService {
  private key = 'infraon_edition';
  private platformId = inject(PLATFORM_ID);
  

  get(): 'saas' | 'enterprise' | null {
    if (isPlatformBrowser(this.platformId)) {
      return localStorage.getItem(this.key) as any;
    }
    return null;
  }

  set(value: 'saas' | 'enterprise') {
    if (isPlatformBrowser(this.platformId)) {
      localStorage.setItem(this.key, value);
    }
  }

  clear() {
    localStorage.removeItem(this.key);
  }
}